export const PRESENTATION_ACTIONS = {
  CREATE: 'create',
  EDIT: 'edit',
  DELETE: 'delete',
  VIEW: 'view',
} as const;

export const PRESENTATION_LABELS = {
  CREATE_PRESENTATION: 'Create Presentation',
  EDIT_PRESENTATION: 'Edit Presentation',
  DELETE_PRESENTATION: 'Delete Presentation',
  PRESENTATION_TITLE: 'Presentation Title',
  STATUS: 'Status',
  DESCRIPTION: 'Description',
  SLIDE_COUNT: 'Slides',
  ACTIONS: 'Actions',
  SEARCH_PRESENTATIONS: 'Search presentations...',
  NO_PRESENTATIONS: 'There are no presentations yet.',
  DELETE_CONFIRMATION:
    'Are you sure you want to delete this presentation? This action cannot be undone.',
  PRESENTATION_CREATED_SUCCESS: 'Presentation created successfully',
  PRESENTATION_UPDATED_SUCCESS: 'Presentation updated successfully',
  PRESENTATION_DELETED_SUCCESS: 'Presentation deleted successfully',
  PRESENTATION_CREATE_ERROR: 'Failed to create presentation',
  PRESENTATION_UPDATE_ERROR: 'Failed to update presentation',
  PRESENTATION_DELETE_ERROR: 'Failed to delete presentation',
  PRESENTATION_FETCH_ERROR: 'Failed to fetch presentations',
} as const;

export const PRESENTATION_VALIDATION = {
  TITLE_MIN_LENGTH: 1,
  TITLE_MAX_LENGTH: 120,
  DESCRIPTION_MAX_LENGTH: 250,
} as const;

export const PRESENTATION_STATUS_CONFIG = {
  IN_PROGRESS: { label: 'In Progress', color: 'bg-[#F3FBFF] text-[#0261B6]' },
  COMPLETED: { label: 'Completed', color: 'bg-[#EFFEF0] text-[#0AA619]' },
  FAILED: { label: 'Failed', color: 'bg-[#FEF5EE] text-[#D5441C]' },
  UNKNOWN: { label: 'Unknown', color: 'bg-[#F5F7F9] text-[#667085]' },
} as const;
